import React from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { PersonalizationFlow } from './pages/PersonalizationFlow';
interface AppProps {
  /** Idioma al que apunta la ruta raíz "/". Las rutas /es y /en siempre existen. */
  defaultLanguage?: 'es' | 'en';
}
export function App({
  defaultLanguage = 'es'
}: AppProps) {
  return <BrowserRouter data-id="element-0" data-mp="3f8ez5k0brtu7">
      <Routes data-id="element-1" data-mp="2rkx49flrkfn0">
        <Route path="/es" element={<PersonalizationFlow language="es" data-id="element-3" data-mp="2rlynw8guiagc" />} data-id="element-2" data-mp="2rkdvopi073ln" />
        <Route path="/en" element={<PersonalizationFlow language="en" data-id="element-5" data-mp="2mmcbu2cr7094" />} data-id="element-4" data-mp="2rikrdguv4vgt" />
        <Route path="*" element={<Navigate to={`/${defaultLanguage}`} replace data-id="element-7" data-mp="31aqdwb2cikom" />} data-id="element-6" data-mp="2mnngs5hxqe1t" />
      </Routes>
    </BrowserRouter>;
}